export default __webpack_public_path__ + "static/media/View profile.a68f4ebc.svg";